import { CLIENT } from '../constants';
import { FetchAPI } from '../Main/fetchAPI';

export const MONDAY_SYNC = `${CLIENT}/monday-sync`;

export interface MondaySyncChangeProperties {
	field: string;
	newValue: unknown;
	oldValue: unknown;
}

export interface MondaySyncLogProperties {
	changes?: MondaySyncChangeProperties[] | null;
	id: string;
	createdAt: string;
	mondayItemId: string;
	itemName?: string;
	outcome: string;
	errorMessage?: string;
	mappedClientId?: string;
	snapshot?: { after?: unknown; before?: unknown } | null;
}

export interface MondaySyncRunProperties {
	id: string;
	startedAt: string;
	completedAt?: string;
	status: string; // Running | Completed | Failed
	trigger: string; // Scheduled | Manual
	totalFetched: number;
	created: number;
	updated: number;
	skipped: number;
	failed: number;
	errorMessage?: string;
	isRunning: boolean;
}

export interface MondaySyncPlannedItemProperties {
	mondayItemId: string;
	itemName?: string;
	plannedOutcome: string; // Create | Update | Skip | Fail
	matchedClientId?: string;
	reason?: string;
}

// Dry run returns the same shape as a real sync result, plus per-item planned outcomes.
export interface MondaySyncDryRunResultProperties {
	totalFetched: number;
	created: number;
	updated: number;
	skipped: number;
	planned: MondaySyncPlannedItemProperties[];
}

export const MondaySync = {
	getLogs: (take = 100) =>
		FetchAPI.getJson({
			urlStr: `${MONDAY_SYNC}/logs?take=${take}`,
		}),
	getStatus: () =>
		FetchAPI.getJson({
			urlStr: `${MONDAY_SYNC}/status`,
		}),
	syncNow: () =>
		FetchAPI.postJson({
			urlStr: MONDAY_SYNC,
			data: {},
		}),
	startDryRun: () =>
		FetchAPI.postJson({
			urlStr: `${MONDAY_SYNC}/dry-run`,
			data: {},
		}),
	getDryRunResult: () =>
		FetchAPI.getJson({
			urlStr: `${MONDAY_SYNC}/dry-run/result`,
		}),
};
